module.exports = __webpack_public_path__ + "34dd9bfaf58697bb01d61e1d6d0a4f8b.png";